<template>
  <span
    class="skeleton"
    :class="{ 'skeleton--rounded': rounded }"
    :style="{ width, height }"
    aria-hidden="true"
    data-cy="skeleton"
  />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    rounded?: boolean;
  }>(),
  {
    width: "100%",
    height: "1rem",
    rounded: true
  }
);
</script>

<style lang="scss" scoped>
.skeleton {
  display: inline-block;
  background-color: #f3f4f6;
  background-image: linear-gradient(
    90deg,
    #f3f4f6 0%,
    #f9fafb 50%,
    #f3f4f6 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s ease-in-out infinite;
  border-radius: 2px;
}
.skeleton--rounded {
  border-radius: 6px;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
    background-image: none;
  }
}
</style>
